import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { faAngleLeft, faAngleRight } from '@fortawesome/pro-light-svg-icons';

import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { ApplyResourceFacetsAction, CancelEditingResourceFacetsAction } from 'search/actions/facet.actions';
import { focusRefineResultsButton, setFilterPanelExpanded, setFilterPanelFullscreen } from 'search/actions/search.actions';
import { ConfigurationLoader } from 'shared/configuration-loader';
import { Breakpoints } from '../../../models/viewport';
import { ViewportService } from '../../../services/viewport.service';
import { WindowRefService } from '../../../services/window-ref.service';

import { FacetFilterBlock } from '../../models/filter-panel';
import { getFilterPanelState, getRapidoMode, State } from '../../reducers/root.reducer';

@Component({
  selector: 'app-filter-panel',
  templateUrl: './filter-panel.component.html',
  styleUrls: ['./filter-panel.component.scss'],
})
export class FilterPanelComponent implements OnInit, OnDestroy {
  @Input() public isFacetsChanged: boolean;
  @Input() public isKidsCatalog: boolean = false;
  @Input() public facetControls: FacetFilterBlock[];
  @ViewChild('closeButton') public closeButton: ElementRef;
  public fixedHeader: boolean;

  public expanded: boolean;
  public fullscreen: boolean;
  public angleLeftIcon = faAngleLeft;
  public angleRightIcon = faAngleRight;
  public isRapidoMode = false;

  private readonly subscriptions = new Subscription();

  constructor(
    private readonly store: Store<State>,
    private readonly windowRef: WindowRefService,
    private readonly viewportService: ViewportService,
    private readonly configLoader: ConfigurationLoader
  ) { }

  public ngOnInit() {
    this.fixedHeader = this.configLoader.headerConfig?.fixedHeader;
    this.subscriptions.add(this.store.pipe(select(getFilterPanelState)).subscribe((filterPanelState) => {
      this.expanded = filterPanelState.expanded;
      this.fullscreen = filterPanelState.fullscreen;
      if (this.fullscreen) {
        setTimeout(() => {
          this.closeButton?.nativeElement.focus();
        });
      }
    }));

    this.subscriptions.add(
      this.store.select(getRapidoMode).subscribe((rapidoMode) => {
        this.isRapidoMode = rapidoMode;
      })
    );

    this.subscriptions.add(
      this.viewportService.isWiderThan(Breakpoints.RESOLUTION_MAX_XS)
      .subscribe((isWiderThanXs) => {
        if (isWiderThanXs && this.fullscreen) {
          this.closeFilterPanel();
        }
      }),
    );
  }

  public onApplyFacets() {
    this.store.dispatch(new ApplyResourceFacetsAction());
  }

  public onCancelEditing() {
    this.store.dispatch(new CancelEditingResourceFacetsAction());
  }

  public closeFilterPanel() {
    this.store.dispatch(setFilterPanelFullscreen({fullscreen: false}));
    this.store.dispatch(focusRefineResultsButton());
  }

  public onExpandToggle(expanded: boolean) {
    this.store.dispatch(setFilterPanelExpanded({expanded}));
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public trackByKey(index: number, item: FacetFilterBlock) {
    return item.key;
  }
}
